import React, { useEffect, useState, useContext } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/adminDashboard.css";
import ViewReports from "./ViewReports";

const AdminDashboard = () => {
  const { user } = useContext(AuthContext); // Corrected to 'user' instead of 'users'
  const navigate = useNavigate();
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch payment requests and user details from Firestore
  useEffect(() => {
    // If the user is not an admin, redirect them to the home page
    if (user.email !== "sumitkarari4@gmail.com") {
      alert("Access denied. Only admins can view this page.");
      navigate("/"); // Redirect to home page
      return; // Ensure that no further execution happens after redirect
    }

    const fetchPaymentRequests = async () => {
      try {
        const paymentRequestsCollection = collection(db, "paymentRequests");
        const paymentRequestsSnapshot = await getDocs(paymentRequestsCollection);

        const requests = await Promise.all(
          paymentRequestsSnapshot.docs.map(async (docSnapshot) => {
            const requestData = docSnapshot.data();

            // Fetch user information based on uid
            let userDetails = { email: "N/A", upiId: "N/A" };
            try {
              const userDoc = await getDocs(collection(db, "users"));
              const uid = requestData.uid;
              const userSnapshot = userDoc.docs.find((u) => u.id === uid);

              if (userSnapshot) {
                userDetails = userSnapshot.data();
              }
            } catch (error) {
              console.error("Error fetching user details:", error.message);
            }

            return {
              id: docSnapshot.id,
              ...requestData,
              email: userDetails.email,
              upiId: userDetails.upiId,
            };
          })
        );

        setPaymentRequests(requests);
      } catch (error) {
        console.error("Error fetching payment requests:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPaymentRequests();
  }, [user, navigate]); // Add user and navigate as dependencies

  // Mark payment as paid or unpaid
  const handlePaymentStatusChange = async (requestId, isPaid) => {
    try {
      const requestRef = doc(db, "paymentRequests", requestId);
      await updateDoc(requestRef, { paid: isPaid });

      setPaymentRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId ? { ...request, paid: isPaid } : request
        )
      );

      alert(`Payment marked as ${isPaid ? "Paid" : "Unpaid"}`);
    } catch (error) {
      console.error("Error updating payment status:", error.message);
      alert("Failed to update payment status. Please try again.");
    }
  };

  if (isLoading) {
    return <div className="admin-dashboard">Loading payment requests...</div>;
  }

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>
      <h2>Payment Requests</h2>

      {paymentRequests.length === 0 ? (
        <p>No payment requests found.</p>
      ) : (
        <table className="payment-requests-table">
          <thead>
            <tr>
              <th>Post ID</th>
              <th>User ID</th>
              <th>Email</th>
              <th>UPI ID</th>
              <th>Likes</th>
              <th>Payment Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paymentRequests.map((request) => (
              <tr key={request.id}>
                <td>{request.postId}</td>
                <td>{request.uid}</td>
                <td>{request.email}</td>
                <td>{request.upiId}</td>
                <td>{request.likeCount}</td>
                <td>{request.paid ? "Paid" : "Unpaid"}</td>
                <td>
                  {request.paid ? (
                    <button
                      onClick={() => handlePaymentStatusChange(request.id, false)}
                      className="unpaid-button"
                    >
                      Mark as Unpaid
                    </button>
                  ) : (
                    <button
                      onClick={() => handlePaymentStatusChange(request.id, true)}
                      className="paid-button"
                    >
                      Mark as Paid
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <h1>To view reports</h1>
      <ViewReports />
    </div>
  );
};

export default AdminDashboard;
